import { DragDropContext } from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

// Singleton component; checks to see if and HTML5 backend has been created,
// if it hasn't, create, if so use existing instance
let context
const withDragDropContext = (component) => {
  if (!context) {
    context = DragDropContext(HTML5Backend)
  }
  return context(component)
}

const DragTypes = { COLUMN: 'column' }

export {
  withDragDropContext,
  DragTypes,
}
